{
    "addAdDocOnMap": "Voulez-vous ajouter une annonce à cette endroit de la carte?"
}